import React from 'react';
import { Handle, Position } from 'reactflow';
import { Calculator } from 'lucide-react';
import { BsBraces } from 'react-icons/bs';

const OperationsNode = ({ data }) => {
    const statusStyles = {
        idle: "border-slate-700",
        pending: "border-yellow-400",
        queued: "border-blue-400",
        failed: "border-red-500",
        success: "border-green-500",
        running: "animate-[pulse_1s_infinite] border-green-500",
        approvalNeeded: "animate-[glow_1.5s_infinite] border-orange-500",
        diagnosing: "animate-[pulse_1s_infinite] border-purple-500", // 👈 new line
    };

    // Default to 'idle' if status is not provided or invalid
    const status = data?.status || "idle";
    const isLoading = status === "running" || status === "pending" || status === "diagnosing";

    const hasJsonOutput = data?.jsonOutput === true;

    const operationCount = data.operations?.length || 0;

    return (
        <div className={`w-64 bg-slate-800 border-2 rounded-lg shadow-lg ${statusStyles[status]}`}>
            <div className="p-3 border-b border-slate-700 bg-slate-900/50 rounded-t-lg flex items-center gap-3 justify-between">
                <div className="flex items-center gap-2">
                    <Calculator className="text-orange-400" size={20} />
                    <h3 className="font-bold text-base text-white">Operations</h3>
                </div>
                <div className="flex items-center gap-2">
                    {hasJsonOutput && (
                        <div title="Structured JSON Output Enabled" className="cursor-help">
                            <BsBraces className="h-4 w-4 text-cyan-400" />
                        </div>
                    )}
                    {isLoading && (
                        <div className="animate-spin h-4 w-4 border-2 border-zinc-500 border-t-white rounded-full" />
                    )}
                </div>

            </div>
            <div className="p-3 text-xs text-slate-300 space-y-1">
                <p>
                    <span className="font-semibold text-slate-400">Label:</span> {data.label || 'Perform Operations'}
                </p>
                <p>
                    <span className="font-semibold text-slate-400">Operations Defined:</span> {operationCount}
                </p>
            </div>
            <Handle type="source" position={Position.Right} className="w-3 h-3 !bg-teal-500" />
            <Handle type="target" position={Position.Left} className="w-3 h-3 !bg-rose-500" />
        </div>
    );
};

export default OperationsNode;